"use client";
import { createTheme as e } from "@mui/material/styles";
import t from "./themeConfig.js";
const r = e(t);
export {
  r as default
};
